import { effect, Signal } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CountryType } from '../../core';

export type RegisterCountryTypeChange = (onChange: () => void) => void;

export function postalCodeValidator(
  getCountryType: () => CountryType | null | undefined,
  registerCountryTypeChange?: RegisterCountryTypeChange,
): ValidatorFn {
  let registeredControl: AbstractControl | null = null;
  let countryTypeChangeRegistered = false;

  return (control: AbstractControl): ValidationErrors | null => {
    if (registeredControl !== control) {
      registeredControl = control;
    }

    if (!countryTypeChangeRegistered && registerCountryTypeChange) {
      countryTypeChangeRegistered = true;
      registerCountryTypeChange(() => {
        registeredControl?.updateValueAndValidity({ onlySelf: true });
      });
    }

    const value = (control.value as string | null | undefined)?.trim();
    if (!value) return null;

    if (getCountryType() === CountryType.US) {
      const valid = /^\d{5}(-\d{4})?$/.test(value);
      return valid ? null : { invalidPostalCode: $localize`Enter a valid format.` };
    }

    // Canada: A1B 2C3
    const valid = /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(value.toUpperCase());
    return valid ? null : { invalidPostalCode: $localize`Enter a valid format.` };
  };
}

export function signalCountryChangeRegistrar(countrySignal: Signal<unknown>): RegisterCountryTypeChange {
  return (onChange: () => void) => {
    effect(() => {
      countrySignal();
      onChange();
    });
  };
}
